import React from 'react';
import { Route, Link, Switch, useRouteMatch } from 'react-router-dom';
import cn from 'classnames';

import { Page } from 'ui/components';

import SettingCompanyScreen from './company';
import SettingServiceScreen from './service';
import SettingPricingScreen from './pricing';
import SettingHubScreen from './hub';
import SettingUserScreen from './user';
import SettingUsergroupScreen from './usergroup';
import _ from 'underscore';
import { useSelector } from 'react-redux';

const routes = [
  {
    path: '/setting',
    component: SettingCompanyScreen,
    action: ['manage', 'read_only'],
    menu: 'Perusahaan',
    service: 'nvo.platform.client',
  },
  {
    path: '/setting/service',
    component: SettingServiceScreen,
    action: ['manage', 'read_only'],
    menu: 'Layanan',
    service: 'nvo.tms.service',
  },
  {
    path: '/setting/pricing',
    component: SettingPricingScreen,
    action: ['manage', 'read_only'],
    menu: 'Harga Jual',
    service: 'nvo.tms.pricing',
  },
  {
    path: '/setting/hub',
    component: SettingHubScreen,
    action: ['manage', 'read_only'],
    menu: 'Lokasi Hub',
    service: 'nvo.platform.location.hub',
  },
  {
    path: '/setting/usergroup',
    component: SettingUsergroupScreen,
    action: ['manage', 'read_only'],
    menu: 'Usergroup & Hak Akses',
    service: 'nvo.platform.usergroup',
  },
  {
    path: '/setting/user',
    component: SettingUserScreen,
    action: ['manage', 'read_only'],
    menu: 'Pengguna',
    service: 'nvo.platform.user',
  },
];

const Navbar = () => {
  const [myRoute, setMyRoute] = React.useState(null);
  const match = useRouteMatch();
  const Session = useSelector((state) => state?.Auth?.session);

  const $getPriviledge = async () => {
    setMyRoute(routes);
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  return (
    <div className="list-group list-group-flush">
      {myRoute?.map((r, i) => {
        let comp = null;

        if (Session?.privileges) {
          let x = _.findWhere(Session?.privileges, { service: r?.service });

          if (x) {
            if (r?.action?.includes(x?.action)) {
              comp = (
                <Link
                  key={i}
                  to={r?.path}
                  className={cn(
                    'list-group-item list-group-item-action',
                    match?.url === r?.path ? 'active' : ''
                  )}
                >
                  {r?.menu}
                </Link>
              );
            }
          }
        } else {
          comp = (
            <Link
              key={i}
              to={r?.path}
              className={cn(
                'list-group-item list-group-item-action',
                match?.url === r?.path ? 'active' : ''
              )}
            >
              {r?.menu}
            </Link>
          );
        }

        return comp;
      })}
    </div>
  );
};

const Switcher = () => {
  const [myRoute, setMyRoute] = React.useState(null);

  const $getPriviledge = async () => {
    setMyRoute(routes);
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  return (
    <Switch>
      {myRoute?.map((r, i) => (
        <Route key={i} exact path={r?.path} component={r.component} />
      ))}
    </Switch>
  );
};

const Setting = () => {
  return (
    <Page className="col-md-8 col-sm-12 bordered bg-white">
      <Page.Header title="Pengaturan" className="bg-light" />

      <Page.Body className="row border-top">
        <div className="col-3 m-0 p-0">
          <Navbar />
        </div>
        <div className="col-9 border-start p-0">
          <Switcher />
        </div>
      </Page.Body>
    </Page>
  );
};

export default Setting;
